import React from "react";
import { Loader2 } from "lucide-react";

const variantMap = {
  primary: "bg-sprouts-primary hover:bg-sprouts-primary-dark text-white",
  secondary: "bg-sprouts-secondary hover:bg-sprouts-secondary-dark text-white",
  outline: "bg-white border-2 border-sprouts-primary text-sprouts-primary hover:bg-sprouts-lavender",
  ghost: "bg-transparent text-sprouts-muted hover:bg-slate-100",
  danger: "bg-red-500 hover:bg-red-600 text-white",
};

export default function Button({
  children,
  variant = "primary",
  loading,
  disabled,
  fullWidth,
  className = "",
  type = "button",
  ...rest
}) {
  const isDisabled = disabled || loading;
  return (
    <button
      type={type}
      disabled={isDisabled}
      className={`inline-flex items-center justify-center gap-2 rounded-full px-5 py-3 text-sm font-bold transition-all shadow-sm
        ${variantMap[variant]}
        ${fullWidth ? "w-full" : ""}
        ${isDisabled ? "opacity-60 cursor-not-allowed" : "hover:shadow-md active:scale-[0.98]"}
        ${className}`}
      {...rest}
    >
      {loading && <Loader2 size={16} className="animate-spin" />}
      {children}
    </button>
  );
}
